import { gql } from "graphql-request"

const solana = {
    name: 'solana',
    title: 'Solana Mainnet',
    currency: 'SOL',
    check: true,
    regexp: '([\\W]|^)([0-9a-zA-Z]{42,44})([\\W]|$)',
    noregxp: [
        '([\\W]|^)(0x[0-9a-fA-F]{40})([\\W]|$)',
        '([\\W]|^)((cosmos1|terra1|tcro1|tcrocncl1)[a-zA-HJ-NP-Z0-9]{38,70})([\\W]|$)',
        '([\\W]|^)(cro[0-9a-z]{39})([\\W]|$)',
        '([\\W]|^)(T[\\w]{33})([\\W]|$)',
        '([\\W]|^)(bc1[\\da-zA-Z]{39,59})([\\W]|$)',
        '([\\W]|^)([3,1][\\da-zA-Z]{32,34})([\\W]|$)',
        '([\\W]|^)([0-9A-Z]{58})([\\W]|$)',
        '([\\W]|^)(bnb[0-9a-z]{39})([\\W]|$)',
        '([\\W]|^)([q,p][\\da-zA-Z]{41})([\\W]|$)',
        '([\\W]|^)((addr1)[2-49a-zA-Z][0-9a-zA-Z]{50,98})([\\W]|$)',
        '(\\W|^)((cfx:)[\\w\\d]{42})([\\W]|$)',
        '([\\W]|^)([7,X][\\da-zA-Z]{33})([\\W]|$)',
        '([\\W]|^)([9,A,D][\\da-zA-Z]{33})([\\W]|$)',
        '([\\W]|^)(erd1[a-zA-HJ-NP-Z0-9]{40,70})([\\W]|$)',
        '([\\w]|^)(-?[0-9]\\d*(\\.\\d+)?:[0-9a-fA-F]{64})([\\W]|$)',
        '([\\W]|^)(f[0-9]{1,14})([\\W]|$)',
        '([\\W]|^)(0[x][0-9a-f]{16})([\\W]|$)',
        '([^\\.\\W]|^)((0+\\.){2}(\\d+))([\\W]|$)',
        '([\\W]|^)([L,M][\\da-zA-Z]{33})([\\W]|$)',
        '([\\W]|^)(ltc1[\\da-zA-Z]{39,59})([\\W]|$)',
        '([\\W]|^)(r[\\w]{32,33})([\\W]|$)',
        '([\\W]|^)(G[\\w]{55})([\\W]|$)',
        '([\\W]|^)((tz1|KT1|tz3|tz2)[\\w]{33})([\\W]|$)',
        '([\\W]|^)(T[\\w]{33})([\\W]|$)',
        '([\\W]|^)(t[1,3][\\da-zA-Z]{33})([\\W]|$)',
        '([\\W]|^)(d-[\\da-zA-Z]{32})([\\W]|$)',
    ],
    query: gql`query ($address: String!) {
        solana(network: solana) {
            address(address: {is: $address}){
                balance: balance
                balance_usd: balance(in: USD)
            }
            ins: transfers(receiverAddress: {is: $address}) {
                count
                min_date: minimum(of: date)
                max_date: maximum(of: date)
            }
            currencyIn: transfers(receiverAddress: {is: $address}) {
                count
                currency {
                    symbol
                    address
                    tokenId
                }
            }
            outs: transfers(senderAddress: {is: $address}) {
                count
                min_date: minimum(of: date)
                max_date: maximum(of: date)
            }
            currencyOut: transfers(senderAddress: {is: $address}) {
                count
                currency {
                    symbol
                    address
                    tokenId
                }
            }
        }
    }`,
    checkAddress: 'Fk4Ujj67oY2UpSGEZtZvNi4FbcVs13gF9EG6fdqCsxTF',
}
export { solana }
